import React from 'react';
import useMountedRef from '../../../../hooks/useMountedRef';
import { useTheme } from '../../../../hooks';
import { Button, Text, Input } from '../../../../styleguide';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
} from '@material-ui/core';
import { SPACING } from '../../../../styles/constants';
import ORDER_STATUS from '../../../../actions/orders/helpers/STATUS';

const CancelDialog = props => {
  const { isOpen, onClose, cancelOrder, order } = props;
  const [inputValue, setInputValue] = React.useState('');
  const [isConfirming, setIsConfirming] = React.useState(false);
  const mounted = useMountedRef();
  const theme = useTheme();

  React.useEffect(() => {
    if (
      order.status === ORDER_STATUS.canceled ||
      order.status === ORDER_STATUS.delivered
    ) {
      onClose();
    }
  }, [order, onClose]);

  const onConfirm = () => {
    if (!!inputValue && inputValue === order.id) {
      return cancelOrder(order);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="order-alert-dialog-title"
    >
      <DialogTitle id="order-alert-dialog-title">
        Annulation de la commande
      </DialogTitle>
      <DialogContent>
        <Text size={400}>
          Vous êtes sur le point d'annuler la commande numéro {order.id} pour
          l'établissement{' '}
          <span style={{ color: theme.primaryColor }}>{order.shop.name}</span>.
        </Text>

        <Divider style={{ margin: `${SPACING[200]} 0` }} />

        <Text size={400}>
          Pour supprimer la commande, veuillez entrer l'id de la commande pour
          confirmer <br />
          ID: <span style={{ color: theme.textColor }}>{order.id}</span>
        </Text>
        <Input
          wrapperProps={{ style: { marginTop: SPACING[200] } }}
          label={'Id de la commande'}
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          placeholder={order.id}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} small minimal>
          Retour
        </Button>
        <Button
          onClick={async () => {
            setIsConfirming(true);
            try {
              await onConfirm();
            } finally {
              if (mounted.current) setIsConfirming(false);
            }
          }}
          color="primary"
          styles={
            !inputValue || inputValue !== order.id
              ? {}
              : { backgroundColor: theme.red }
          }
          small
          disabled={!inputValue || inputValue !== order.id || isConfirming}
        >
          Annuler la commande
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelDialog;
